'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteQueryBoxDates', ['$controller', 'TimeService', 'NotesQueryManagementService', function ($controller, TimeService, NotesQueryManagementService) {
      return {
        restrict: 'A',
        templateUrl: 'views/directives/notes/saNoteQueryBoxDates.html',
        link: function(scope, elem, attr) {
          var baseCtrl = $controller('BaseQuerySubscriptionCtrl', {$scope: scope});

          var dates = TimeService.getDayTwixFromDate(TimeService.getNowInStoreTime());

          scope.state = {
            startDatepickerOpen: false,
            endDatepickerOpen: false,
            dates: {
              start: dates.start.toDate(),
              end: dates.end.subtract(1, 'minutes').toDate()
            },
            managementId: scope.managementId
          };

          scope.datePickerOptions = {
            'starting-day': scope.startOfWeekDay,
            'show-weeks': false
          };

          scope.openDatepicker = function(which, $event) {
            $event.preventDefault();
            $event.stopPropagation();

            if (which == 'start') {
              if (scope.state.startDatepickerOpen === true) {
                scope.state.startDatepickerOpen = false;
              } else {
                scope.state.startDatepickerOpen = true;
              }
            } else if (which == 'end') {
              if (scope.state.endDatepickerOpen === true) {
                scope.state.endDatepickerOpen = false;
              } else {
                scope.state.endDatepickerOpen = true;
              }
            }
          };

          scope.datesChanged = function() {
            throttledUpdate();
          };

          var throttledUpdate = _.throttle(function() {
            if (!scope.state.dates.start || !scope.state.dates.end) {
              return;
            }

            var startTwix = TimeService.getDayTwixFromDate(scope.state.dates.start);
            var endTwix = TimeService.getDayTwixFromDate(scope.state.dates.end);

            var q = baseCtrl.getQuery();
            if (q.obj === null) {
              q.obj = 'date';
            }
            q.dates = {
              start: startTwix.start,
              end: endTwix.end
            };
            q.custom = true;
            baseCtrl.setQuery(q);
          }, 250);

          var update = function(currentQuery) {
            if (currentQuery.dates && currentQuery.dates.start && currentQuery.dates.end) {
              scope.state.dates.start = currentQuery.dates.start.toDate();
              var endTwix = TimeService.getDayTwixFromDate(moment(currentQuery.dates.end).subtract(12, 'hours').toDate());
              scope.state.dates.end = endTwix.start.toDate();
            } else {
              scope.state.dates = {};
            }
          };

          // Base ctrl
          baseCtrl.initialize('QueryBoxDates', scope.managementId);
          baseCtrl.setRenderCallback(update);
          baseCtrl.updateMyself();

          scope.$on('$destroy', function() {
            baseCtrl.uninitialize();
            baseCtrl = undefined;
          });
      }
    }
  }]);
